import { useEffect, useState } from 'react'
import { CIMSBasicFieldProps } from '../../../CIMSBasicFields/types'
import { useFoundCallback } from './useFoundCallback'
import { TextValue } from '../../types'

export function useTextCustomFields(
  textValues?: TextValue[]
): CIMSBasicFieldProps[] {
  const [fields, setFields] = useState<CIMSBasicFieldProps[]>([])
  const found = useFoundCallback()
  useEffect(() => {
    if (!textValues) return
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setFields(
      textValues.map(({ customFieldId, value, customField }) =>
        found({ customField, customFieldId, children: value })
      )
    )
  }, [found, textValues])
  return fields
}
